import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { EditLinks } from '../../../../@core/constants/edit-links';
import { ListLinks } from '../../../../@core/constants/list-links';
import { BaseDetailComponent } from '../../../../common/base-detail.component';
import { Bank } from '../../../../generated/generated-types';
import { WidgetBaseDetailComponent } from '../../../../shared/components/widget-base-detail/widget-base-detail.component';
import { HotkeysService } from '../../../hotkeys/services/hotkeys.service';
import { BankService } from '../../services/bank.service';
import { bankFallbackFields } from './bank-fallback-fields';

@Component({
  selector: 'app-bank-edit-widget',
  templateUrl: '../../../../common/base-detail.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  providers: [HotkeysService],
  imports: [
    WidgetBaseDetailComponent
  ]
})
export class BankEditWidgetComponent extends BaseDetailComponent<Bank> implements OnInit {

  private bankService = inject(BankService);
  protected override crudService = this.bankService;


  ngOnInit() {
    this.listLink = ListLinks.BANK;
    this.editLink = EditLinks.BANK;
    this.fallbackFields = bankFallbackFields();
    super.ngOnInit();
  }

}
